<template>
  <span v-bind="$attrs" class="Pictogram" :class="sizes" :user="user" v-tippy="tippyContent">
    {{ getInicials }}
  </span>
  <span v-if="showname" class="pl-2">{{ user.name }} {{ user.surname }}</span>
</template>

<script>
export default {
  props: {
    size: String,
    user: Object,
    forceTitle: String,
    showname: { type: Boolean, default: false },
    forceContent: [String, Number],
    tooltipContent: { type: [String, Object], default: null },
  },
  data() {
    return {}
  },
  computed: {
    sizes() {
      return {
        'Pictogram--L': this.size == 'large' || this.size == 'l',
        'Pictogram--XL': this.size == 'xl'
      }
    },
    getInicials() {
      if (this.forceContent !== undefined) {
        return this.forceContent
      }
      if (this.user !== undefined && this.user) {
        return this.user.inicials
      }
      return '?'
    },
    tippyContent() {
      if (this.tooltipContent) {
        return this.tooltipContent
      }

      if (this.forceTitle !== undefined) {
        return this.forceTitle
      }
      if (this.user !== undefined && this.user) {
        if (
          (this.user.name != '' && this.user.name != '?') ||
          (this.user.surname != '' && this.user.surname != '?')
        ) {
          return `${this.user.name} ${this.user.surname}`
        } else {
          return `${this.user.email}`
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
